module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ed-aside-menu"
  }, [_c('div', {
    staticClass: "ed-aside-menu__page from-left"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.parentPage !== 'asideHome'),
      expression: "parentPage !== 'asideHome'"
    }],
    staticClass: "ed-aside-menu__previous",
    on: {
      "click": _vm.backHome
    }
  }, [_c('span', {
    staticClass: "icon-back-button-white"
  }), _vm._v("Accueil")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.parentPage !== 'asideHome'),
      expression: "parentPage !== 'asideHome'"
    }],
    staticClass: "ed-aside-menu__path-container"
  }, [_vm._v("\n      >\n      "), _vm._l((_vm.path), function(item, index) {
    return _c('span', [_c('div', {
      staticClass: "ed-aside-menu__path",
      class: {
        'no-link': !item.id, 'current': _vm.folder.id === item.id
      },
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < _vm.path.length - 1),
        expression: "index < path.length - 1"
      }]
    }, [_vm._v("/")])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "ed-aside-menu__list"
  }, _vm._l((_vm.newFolders), function(child) {
    return _c('li', [(child.listId) ? _c('dropdown-menu', {
      attrs: {
        "name": child.name,
        "id": "asideSubMenu" + child.id
      }
    }, [(_vm.subMenuList(child.listId)) ? _c('dropdown-menu-content', _vm._l((_vm.subMenuList(child.listId).redirections), function(link) {
      return _c('dropdown-menu-item', {
        key: "submenu"
      }, [_vm._v("\n              " + _vm._s(link.name) + "\n            ")])
    }), 1) : _vm._e()], 1) : _c('div', {
      staticClass: "ed-aside-menu__link",
      domProps: {
        "innerHTML": _vm._s(child.name)
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "ed-aside-menu__page main-page",
    attrs: {
      "id": _vm.parentPage
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.parentPage !== 'asideHome'),
      expression: "parentPage !== 'asideHome'"
    }],
    staticClass: "ed-aside-menu__previous",
    on: {
      "click": _vm.backHome
    }
  }, [_c('span', {
    staticClass: "icon-back-button-white"
  }), _vm._v("Accueil")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.parentPage !== 'asideHome'),
      expression: "parentPage !== 'asideHome'"
    }],
    staticClass: "ed-aside-menu__path-container"
  }, [_vm._v("\n      >\n      "), _vm._l((_vm.path), function(item, index) {
    return _c('span', [_c('div', {
      staticClass: "ed-aside-menu__path",
      class: {
        'no-link': !item.id, 'current': _vm.parentPage === item.id
      },
      domProps: {
        "innerHTML": _vm._s(item.name)
      },
      on: {
        "click": function($event) {
          return _vm.asideMenuAnimation(item.id, _vm.parentPage)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < _vm.path.length - 1),
        expression: "index < path.length - 1"
      }]
    }, [_vm._v("/")])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "ed-aside-menu__list"
  }, _vm._l((_vm.asideCurrentFolders), function(child) {
    return _c('li', [(child.listId) ? _c('dropdown-menu', {
      attrs: {
        "name": child.name,
        "id": "asideSubMenu" + child.id
      }
    }, [(_vm.subMenuList(child.listId)) ? _c('dropdown-menu-content', _vm._l((_vm.subMenuList(child.listId).redirections), function(link) {
      return _c('dropdown-menu-item', {
        key: "submenu",
        nativeOn: {
          "click": function($event) {
            return _vm.asideMenuAnimation(link.id, child.parent, child.id)
          }
        }
      }, [_vm._v("\n              " + _vm._s(link.name) + "\n            ")])
    }), 1) : _vm._e()], 1) : _c('div', {
      staticClass: "ed-aside-menu__link",
      class: {
        'active': child.id === _vm.activePanel
      },
      domProps: {
        "innerHTML": _vm._s(child.name)
      },
      on: {
        "click": function($event) {
          if (child.triggerView) {
            child.triggerView(child.id)
          } else {
            _vm.asideMenuAnimation(child.id, child.parent);
          }
        }
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "ed-aside-menu__page from-right",
    attrs: {
      "id": _vm.parentPage
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.parentPage !== 'asideHome'),
      expression: "parentPage !== 'asideHome'"
    }],
    staticClass: "ed-aside-menu__previous",
    on: {
      "click": _vm.backHome
    }
  }, [_c('span', {
    staticClass: "icon-back-button-white"
  }), _vm._v("Accueil")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.parentPage !== 'asideHome'),
      expression: "parentPage !== 'asideHome'"
    }],
    staticClass: "ed-aside-menu__path-container"
  }, [_vm._v("\n      >\n      "), _vm._l((_vm.path), function(item, index) {
    return _c('span', [_c('div', {
      staticClass: "ed-aside-menu__path",
      class: {
        'no-link': !item.id, 'current': _vm.folder.id === item.id
      },
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < _vm.path.length - 1),
        expression: "index < path.length - 1"
      }]
    }, [_vm._v("/")])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "ed-aside-menu__list from-right"
  }, _vm._l((_vm.newFolders), function(child) {
    return _c('li', [(child.listId) ? _c('dropdown-menu', {
      attrs: {
        "name": child.name,
        "id": "asideSubMenu" + child.id
      }
    }, [(_vm.subMenuList(child.listId)) ? _c('dropdown-menu-content', _vm._l((_vm.subMenuList(child.listId).redirections), function(link) {
      return _c('dropdown-menu-item', {
        key: "submenu"
      }, [_vm._v("\n              " + _vm._s(link.name) + "\n            ")])
    }), 1) : _vm._e()], 1) : _c('div', {
      staticClass: "ed-aside-menu__link",
      domProps: {
        "innerHTML": _vm._s(child.name)
      }
    })], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8f005ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/edoc-library/src/components/edAsideMenu/edAsideMenu.vue
// module id = 715
// module chunks = 42